module.exports = __webpack_public_path__ + "Avatar-Water-Polo-Womens.jpg";